// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RichTextSlice_wrapper__61424","left":"RichTextSlice_left__47b81","center":"RichTextSlice_center__be308","right":"RichTextSlice_right__f9d35"};